<template>

</template>

<script>

export default {
  props: {
    powerMode: {
      type: [Boolean, Number],
      default: false,
    },
  },
  computed: {
    powerModeSetting() {
      return Boolean(this.powerMode)
    },
  },
  created() {
    this.$store.commit('builder/setPowerMode', this.powerModeSetting)
    if (this.powerModeSetting)
        console.log('[Power mode enabled]')
  }
}
</script>
